import { Flex } from '@mantine/core'
import styled from 'styled-components'

interface TreeChartItemProps {
  size: number
  left: number
  top: number
  width: number
  height: number
}

export const TreeChartBoxStyled = styled.div<Pick<TreeChartItemProps, 'width' | 'height'>>`
  position: relative;
  margin-left: -4px;
  margin-top: -4px;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height ?? 410}px;

  &[data-ar='true'] {
    margin-right: -4px;
  }
`

export const TreeChartItemStyled = styled(Flex)<TreeChartItemProps>`
  position: absolute;
  /* opacity: 0.8; */
  flex-direction: column;
  transition: opacity 0.3s;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height ?? 410}px;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  cursor: pointer;
  box-sizing: border-box;

  .symbol {
    font-weight: 500;
    color: #fff;
    font-size: ${({ size }) => size * 0.8}px;
  }

  .price {
    font-weight: 400;
    color: #fff;
    font-size: ${({ size }) => size / 3}px;
  }

  .percentage {
    font-weight: 400;
    color: var(--color-text-6);
    font-size: ${({ size }) => size / 3.2}px;
  }
`

export const HeatFloatingStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const HeatFloatingCoinStyled = styled.div`
  display: flex;
  gap: 8px;
  span {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }
  strong {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
  }
`

export const HeatFloatingRateStyled = styled.div`
  display: flex;
  align-items: center;
  .iconpark-icon {
    width: 12px;
    height: 12px;
  }
  span {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
  }
`
